/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCoinMemeListRequest = {
    sortField?: AptosCoinMemeListRequest.sortField;
    sortDirection?: AptosCoinMemeListRequest.sortDirection;
    type?: AptosCoinMemeListRequest.type;
    page?: number;
    size?: number;
};

export namespace AptosCoinMemeListRequest {

    export enum sortField {
        PRICE = 'PRICE',
        AGE = 'AGE',
        PRICE_CHANGE_5M = 'PRICE_CHANGE_5M',
        PRICE_CHANGE_1H = 'PRICE_CHANGE_1H',
        PRICE_CHANGE_6H = 'PRICE_CHANGE_6H',
        PRICE_CHANGE_24H = 'PRICE_CHANGE_24H',
        MARKET_CAP = 'MARKET_CAP',
        FDV = 'FDV',
        HOLDER = 'HOLDER',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum type {
        ALL = 'ALL',
        COIN = 'COIN',
        FUNGIBLE_ASSET = 'FUNGIBLE_ASSET',
    }


}

